import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';

import About from './About';
import Team from './Team';
import Locations from './Locations';
import Contact from './Contact';
import ThankYou from './ThankYou';

function App() {
  return (
    <div>
    <BrowserRouter>
      <Header />
      <div className="App">
        <Routes>
          <Route path="/" element={<About/>}/>
          <Route path="/team" element={<Team/>}/>
          <Route path="/locations" element={<Locations/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/thank-you" element={<ThankYou/>}/>
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  </div>
  );
}

export default App;
